import React from 'react';
import { ShieldCheckIcon, BadgeDollarSignIcon, MapPinIcon } from 'lucide-react';
export function HeroSection() {
  return <section id="home" className="relative min-h-screen flex items-end pb-16 sm:pb-24 pt-24 sm:pt-32 parallax-bg" style={{
    backgroundImage: 'url("https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1920&q=80")'
  }} data-id="element-129">
      {/* Full dark wash overlay */}
      <div className="absolute inset-0 bg-black/50" data-id="element-130" />
      {/* Extra bottom gradient for text area */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-131" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 text-center" data-id="element-132">
        <div className="max-w-5xl mx-auto" data-id="element-133">
          <h1 className="text-[32px] sm:text-4xl md:text-6xl lg:text-[72px] font-[900] text-white mb-6 sm:mb-10 leading-[1.1] tracking-tight" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.6)'
        }} data-id="element-134">
            Premium Shade Solutions for Arizona Living
          </h1>

          <p className="text-base sm:text-lg md:text-2xl text-white/90 mb-8 sm:mb-14 font-medium max-w-3xl mx-auto leading-relaxed" style={{
          textShadow: '0 1px 8px rgba(0,0,0,0.4)'
        }} data-id="element-135">
            Motorized & Manual Interior and Exterior Window Treatments —
            Manufactured in Phoenix, AZ
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 mb-10 sm:mb-20" data-id="element-136">
            <a href="#contact" className="w-full sm:w-auto bg-gold hover:bg-gold-hover text-charcoal font-bold px-8 py-4 min-h-[48px] rounded-full transition-all text-base sm:text-lg shadow-lg hover:shadow-xl hover:-translate-y-0.5 flex items-center justify-center" data-id="element-137">
              Book a Free Consultation
            </a>
            <a href="#products" className="w-full sm:w-auto border-2 border-white text-white hover:bg-white/10 font-bold px-8 py-4 min-h-[48px] rounded-full transition-all text-base sm:text-lg backdrop-blur-sm flex items-center justify-center" data-id="element-138">
              Explore Our Products
            </a>
          </div>

          {/* Trust Strip */}
          <div className="flex flex-col sm:flex-row flex-wrap items-center justify-center gap-3 sm:gap-x-8 sm:gap-y-4 text-white/80 text-sm md:text-base font-medium" data-id="element-139">
            <div className="flex items-center gap-2" data-id="element-140">
              <ShieldCheckIcon className="w-5 h-5 text-gold" data-id="element-141" />
              <span data-id="element-142">Proudly U.S.A. Made</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-white/30" data-id="element-143" />
            <div className="flex items-center gap-2" data-id="element-144">
              <BadgeDollarSignIcon className="w-5 h-5 text-gold" data-id="element-145" />
              <span data-id="element-146">Financing Available</span>
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-white/30" data-id="element-147" />
            <div className="flex items-center gap-2" data-id="element-148">
              <MapPinIcon className="w-5 h-5 text-gold" data-id="element-149" />
              <span data-id="element-150">Serving Scottsdale & Greater Phoenix</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}